
// => Styling
import styles from './IconButton.module.css';

// => Icons
import { IoBug } from "react-icons/io5";

// => 3rd party components
import { Tooltip } from 'react-tooltip';


// ============
// Component
// ============
const IconButton = ({
    id = "none",
    icon = null,
    tooltip = null,
    onClick = () => {},
    onHover = () => {},
}) => {


    // RENDER
    // ---------
    return(
        <button className={styles.container}
                onClick={onClick}
                onPointerEnter={onHover}
                data-tooltip-id={id}
                data-tooltip-place='bottom-end'
                data-tooltip-offset={10}
                data-tooltip-variant='dark'>
            {icon ?
            icon :
            <IoBug />}
            {tooltip &&
            <Tooltip id={id} style={{fontSize: '.5em', userSelect: 'none'}}>
                {tooltip}
            </Tooltip>}
        </button>
    )
}


export default IconButton